import React, { Fragment } from 'react';

// import PropTypes from 'prop-types';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { get, size, isEmpty, find, map } from 'lodash';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { sliderCarausel as SliderCarausel } from 'ui/views/sliderCarausel';
import classnames from 'classnames';
import { inputFieldCheckbox as InputFieldCheckbox } from 'ui/views/generic/inputFieldCheckbox';
import { button as Button } from 'modules/button';
import { isVisible } from 'resolvers/getVisibleEntities';

const accessManagementPermissionsPreloader = () => {
    return (
        <div className= 'ui-access-management-permissions-view__preloader'>
            <div className='ui-access-management-permissions-view__preloader__header'>
                <div className='ui-access-management-permissions-view__preloader__header__title'></div>
                <div className='ui-access-management-permissions-view__preloader__header__action'></div>
            </div>

            <div className='ui-access-management-permissions-view__preloader__body'>
                {
                    [ 1, 2, 3 ].map( () => {
                        return(
                            <div className='ui-access-management-permissions-view__preloader__body__data'></div>
                        );
                    } )
                }
            </div>

        </div>
    );
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { accessManagementPermissionsView as AccessManagementPermissionsView } from 'ui/views/accessManagementPermissionsView';
 *
 * // render
 * <AccessManagementPermissionsView propName='propValue'/>
 */
const _accessManagementPermissionsView = ( props ) => {

    const isEditMode = get( props, 'isEditMode', false );
    const structure = get( props, 'componentData.structure', {} );
    const navActions = get( structure, 'actions', {} );
    const headerActions = get( structure, 'navActions', {} );
    const editHeaderAction = find( headerActions, { type: 'editPermissions' } );

    return (
        <div className='ui-access-management-permissions-view'>
            <div className='ui-access-management-permissions-view__header'>
                <h5 className='ui-access-management-permissions-view__header__title'>
                    { getLabel( structure.title ) }
                </h5>
                {
                    isVisible( editHeaderAction, get( props, 'componentdata.visibility', {} ) ) && !isEditMode ? (
                        <div
                            className='ui-access-management-permissions-view__header__icon'
                            onClick={() => props.toggleEditMode()}
                        >
                            <Icon name='editIcon' width='17' height='17' fill='#000000' />
                        </div>
                    ) : null
                }
            </div>

            <div className='ui-access-management-permissions-view__container'>

                <div className='ui-access-management-permissions-view__container__header'>
                    <SliderCarausel
                        listSize = { size( props.items ) }
                        overflowCount={ props.sliderBreakDownVar }
                        onSlide={ ( index ) => props.getSliderMapBasedOnIndex( index ) }
                        classNames = { 'ui-access-management-permissions-view__container__header__left' }
                    >
                        <_RenderList
                            { ...props }
                        />
                    </SliderCarausel>
                </div>
                <div className='ui-access-management-permissions-view__container__permissions'>
                    <RenderPermissionList
                        { ...props }
                    />
                </div>

                {
                    isEditMode ? <div className='ui-access-management-permissions-view__container__navigations'>
                         { map( navActions, action => {
                                        const actionName = action.name;

                                        return (
                                            <Button
                                                key={ actionName }
                                                id= { actionName }
                                                type= { 'submit' !== actionName ? 'button' : 'submit' }
                                                disabled={ 'cancel' !== actionName ? props.disableSubmit || props.isSubmitting : false }
                                                outline={ 'cancel' === actionName ? true : false }
                                                size='large'
                                                className='ui-service-now__body__form__actions__action'
                                                onClick = {
                                                    'cancel' === actionName ?
                                                    () => props.toggleEditMode() : () => props.handlePermissionsUpdate( { url: action.url } )
                                                }
                                                loading ={ 'submit' === actionName ? props.isSubmitting : false }
                                                { ...action }
                                            />
                                        );
                                    } ) }
                   
                    </div> : null
                }
            </div>
        </div>
    );
};

export const accessManagementPermissionsView = withNetworkState( accessManagementPermissionsPreloader, _accessManagementPermissionsView );

// set display name
accessManagementPermissionsView.displayName = 'accessManagementPermissionsView';

// set default props
accessManagementPermissionsView.defaultProps = {};

// prop types
accessManagementPermissionsView.propTypes = {};

const _RenderList = ( props ) => {
    const { listRef, listItemRef } = props;

    const roleOptions = get( props, 'componentData.options.roleOptions', [] );

    const classNames = classnames( 'ui-access-management-permissions-view__container__header__section', props.classNames );

    return (
        <div className = { classNames }>
            <ul className = 'ui-access-management-permissions-view__container__header__section__list' ref = { listRef }>

            {
                    !isEmpty( roleOptions ) && roleOptions.map( ( roleOption, index  ) => {

                        return (
                            <li className= 'ui-access-management-permissions-view__container__header__section__list__item' ref={listItemRef} key={ `permission_Header_${ roleOption.value }__${ index }`}>

                                {
                                    getLabel( roleOption.title )
                                }

                            </li>
                        );

                    } )
                }

            </ul>

        </div>
    );
};

// set display name
_RenderList.displayName = '_RenderList';

const RenderPermissionList = ( props ) => {

    const isEditMode = get( props, 'isEditMode', false );
    const updatedSliderMap = get( props, 'updatedSliderMap', [] );
    const roleOptions = get( props, 'componentData.options.roleOptions', [] );
    const resourcesOptions = get( props, 'componentData.options.resourcesOptions', [] );
    const items = get( props, 'items', [] );


    return (
        <Fragment>
            <ul className = 'ui-access-management-permissions-view__container__permissions__list' >

                {
                    !isEmpty( resourcesOptions ) && resourcesOptions.map( ( permissionResource, index ) => {

                        return(
                            <div className='ui-access-management-permissions-view__container__permissions__list__item' key={ `permission_${ permissionResource.value }__${ index }`} >

                                <h5 className='ui-access-management-permissions-view__container__permissions__list__item__title' >
                                    { getLabel( permissionResource.title ) }
                                </h5>

                                <div className='ui-access-management-permissions-view__container__permissions__list__item__permission'>
                                
                                {
                                    !isEmpty( updatedSliderMap ) && updatedSliderMap.map( ( permission  ) => {

                                        const roleValue = get( find( roleOptions, { id: permission } ), 'value', '' );
                                        const permissions = get( find( items, { roleId: roleValue } ), 'permissions', [] );
                                        const permissionConfig = find( permissions, { value: permissionResource.value } );
                                        
                                        return (
                                                
                                            <li className='ui-access-management-permissions-view__container__permissions__list__item__permission__value' key={ `list__${ permissionResource.value }_${ roleValue}`}>

                                                <InputFieldCheckbox
                                                    name= { `permission__${ permissionResource.value }_${ roleValue}` }
                                                    value = { get( permissionConfig, 'checked', false ) }
                                                    disabled = { !isEditMode }
                                                    onChange = { ( { value } = {} ) => { props.handlePermissionChange( { value: value, role: roleValue, permission: permissionResource.value } ); } }
                                                    showLabel = { true }
                                                    error = { {} }
                                                    label = { {} }
                                                />
                                                
                                            </li>
                                        );
                
                                    } )
                                }

                                </div>

                            </div>
                        );

                    } )
                }

            </ul>
        </Fragment>

    );
};

// set display name
RenderPermissionList.displayName = 'RenderPermissionList';
